import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Free Shipping Banner */}
      <div className="bg-emerald-600 text-white py-2 px-4 text-center text-sm font-medium">
        <i className="ri-truck-line mr-2"></i>
        FREE SHIPPING ON ALL ORDERS - NO MINIMUM PURCHASE REQUIRED
        <i className="ri-truck-line ml-2"></i>
      </div>

      {/* Main Navigation */}
      <nav className={`fixed top-8 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <div className="flex items-center space-x-12">
              <a href="/" className="flex items-center space-x-2">
                <div className={`text-2xl font-bold transition-colors ${
                  isScrolled ? 'text-emerald-700' : 'text-white'
                }`}>
                  The Luxora Collection
                </div>
              </a>
              <div className="hidden md:flex items-center space-x-8">
                <a href="/health-wellness" className={`text-sm font-medium transition-colors hover:text-emerald-600 whitespace-nowrap ${
                  isScrolled ? 'text-gray-700' : 'text-white'
                }`}>
                  Health & Wellness
                </a>
                <a href="/skincare" className={`text-sm font-medium transition-colors hover:text-emerald-600 whitespace-nowrap ${
                  isScrolled ? 'text-gray-700' : 'text-white'
                }`}>
                  Skincare
                </a>
                <a href="/personal-care" className={`text-sm font-medium transition-colors hover:text-emerald-600 whitespace-nowrap ${
                  isScrolled ? 'text-gray-700' : 'text-white'
                }`}>
                  Personal Care
                </a>
                <a href="/natural-care" className={`text-sm font-medium transition-colors hover:text-emerald-600 whitespace-nowrap ${
                  isScrolled ? 'text-gray-700' : 'text-white'
                }`}>
                  Natural Care
                </a>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <button className={`p-2 rounded-lg transition-colors hover:bg-emerald-50 ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}>
                <i className="ri-search-line text-xl"></i>
              </button>
              <button className={`p-2 rounded-lg transition-colors hover:bg-emerald-50 ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}>
                <i className="ri-user-line text-xl"></i>
              </button>
              <button className={`p-2 rounded-lg transition-colors hover:bg-emerald-50 relative ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}>
                <i className="ri-shopping-cart-line text-xl"></i>
                <span className="absolute -top-1 -right-1 bg-emerald-600 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
                  0
                </span>
              </button>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}